<dxp-link-selector *ngIf="this.gridActionItems.length > 1" selector-id="gridActions" class="action-block"
    data-source-key-name="value" 
    [items]="this.gridActionItems"
    (selectedItemChanged)="setSelectedAction($event)"
    search-placeholder="Actions" 
    [placeholder]="this.placeholder" 
    optional=true
    list-aria-label="List of actions" #actionsDropDown>
</dxp-link-selector>
<dxp-link *ngIf="this.gridActionItems.length == 1" link-id="action-link" state="enabled" open-in-new-tab="false" type="dxp-btn-custom-link" [text]="this.gridActionItems[0].value"
    aria-label="Link to execute action" (click)="callSingleAction()" >
</dxp-link>